<template>
  <div class="xin xin_custom">
    <div class="switch1" v-if="this.list_custom_one == 1">
      <el-tabs>
        <!-- 数据统计  -->

        <el-tab-pane label="数据统计">
          <span slot="label">
            {{ $t("logs.statistics19") }}
          </span>
            <!-- 数据展示 -->

          <div class="switch1">
            <div class="main" style="margin-bottom:10px;padding:10px">
            {{$t("logs.custom_list_prompts") }}

            </div>
            <div class="table custom_for_table" v-loading="refresh_loading">
              <ul v-for="v in fileList5" :key="v.id" class="custom_for">
                  <el-link type="primary" @click="handleClick1(v.RULE)">  {{ v.RULE }} (
                    <span class="custom_for_span" v-show="v.color_show==1" style="color:#f00">{{ v.NUM }}</span>
                  <span class="custom_for_span" v-show="v.color_show==0" >{{ v.NUM }}</span>
                  )</el-link>
               
              </ul>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div
      class="switch"
      v-if="this.list_custom_two == 1"
     
    >
    <!--  style="overflow: hidden" -->
      <div class="fang_mail_custom">
        <div id="detail_type">
          <div class="switch" v-show="this.list_first == 1">
            <!-- 查询框 -->
            <div class="main main_custom_insulate" v-if="this.ping_an_show==3">
              <el-form ref="form" label-width="80px">
                <ul>
                  <li>{{ $t("wasteInsulate1.envfrom") }}:</li>
                  <el-input
                    placeholder
                    v-model="col.envfrom"
                    clearable
                  ></el-input>
                  <li>{{ $t("wasteInsulate1.envrcpt") }}:</li>
                  <el-input
                    placeholder
                    v-model="col.envrcpt"
                    clearable
                  ></el-input>
                  <li>{{ $t("wasteInsulate1.subject") }}:</li>
                  <el-input
                    placeholder
                    v-model="col.subject"
                    clearable
                  ></el-input>
                  <li>{{ $t("wasteInsulate1.ip") }}:</li>
                  <el-input placeholder v-model="col.ip" clearable></el-input>
                  <el-button @click="tanSend">{{
                    $t("table.search")
                  }}</el-button>
                  <el-button
                    @click="xians()"
                    v-show="geng"
                    type="text"
                    class="more_s"
                    >{{ $t("table.more") }}
                  </el-button>
                  <el-button
                    @click="xians()"
                    v-show="geng1"
                    type="text"
                    class="more_d"
                    >{{ $t("table.more1") }}</el-button
                  >
                </ul>
              </el-form>
              <div class="search" v-show="xian">
                <ul   v-if="this.ping_an_show==0">
                  <li>{{ $t("wasteInsulate1.hdrfrom") }}:</li>
                  <el-input
                    placeholder
                    v-model="col.hdrfrom"
                    clearable
                  ></el-input>

                  <li>{{ $t("wasteInsulate1.hdrto") }}:</li>

                  <el-input
                    placeholder
                    v-model="col.hdrto"
                    clearable
                  ></el-input>
                  <li>{{ $t("wasteInsulate1.attach") }}:</li>
                  <el-input
                    placeholder
                    v-model="col.attach"
                    clearable
                  ></el-input>
                  <li>{{ $t("wasteInsulate1.attnum") }}:</li>
                  <el-input placeholder="" v-model="col.nbattach">
                    <el-select
                      v-model="col.achunit"
                      slot="prepend"
                      placeholder=""
                    >
                      <el-option label=">=" value="1"></el-option>
                      <el-option label="<=" value="2"></el-option>
                      <el-option label="=" value="3"></el-option>
                    </el-select>
                  </el-input>
                </ul>
                <ul   v-if="this.ping_an_show==0">
                  <li>{{ $t("wasteInsulate1.mid") }}:</li>

                  <el-input placeholder v-model="col.mid" clearable></el-input>
                  <li>{{ $t("wasteInsulate1.url") }}:</li>
                  <el-input placeholder v-model="col.url" clearable></el-input>
                  <li>{{ $t("wasteInsulate1.bccnum") }}:</li>
                  <el-input placeholder="" v-model="col.nbbcc">
                    <el-select
                      v-model="col.bccunit"
                      slot="prepend"
                      placeholder=""
                    >
                      <el-option label=">=" value="1"></el-option>
                      <el-option label="<=" value="2"></el-option>
                      <el-option label="=" value="3"></el-option>
                    </el-select>
                  </el-input>

                  <li>{{ $t("wasteInsulate1.alinknum") }}:</li>
                  <el-input placeholder="" v-model="col.nblink">
                    <el-select
                      v-model="col.linkunit"
                      slot="prepend"
                      placeholder=""
                    >
                      <el-option label=">=" value="1"></el-option>
                      <el-option label="<=" value="2"></el-option>
                      <el-option label="=" value="3"></el-option>
                    </el-select>
                  </el-input>
                </ul>
                <ul   v-if="this.ping_an_show==0">
                  <li>{{ $t("wasteInsulate1.body") }}:</li>

                  <el-input placeholder v-model="col.body" clearable></el-input>

                  <li>{{ $t("wasteInsulate1.istls") }}:</li>

                  <el-select v-model="col.istls" placeholder>
                    <el-option
                      v-for="item in istls_arr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <li>{{ $t("wasteInsulate1.haspass") }}:</li>

                  <el-select v-model="col.haspass">
                    <el-option
                      v-for="item in haspass1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <li>{{ $t("wasteInsulate1.type") }}:</li>

                  <el-select v-model="col.type">
                    <el-option
                      v-for="item in type1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </ul>
                <ul v-if="this.ping_an_show==0">
                  <li  >{{ $t("wasteInsulate1.minion_host") }}:</li>

                  <el-select v-model="col.minion_host"  >
                    <el-option
                      v-for="item in minionhost"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <li   >{{ $t("logs.Policy_list8") }}:</li>
                  <el-select v-model="col.isout" placeholder   >
                    <el-option
                      v-for="item in isout_arr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <li  >{{ $t("wasteInsulate1.spam_reason") }}:</li>

                  <el-select   
                    v-model="col.spam_reason"
                    placeholder
                    @change="spam_reason_change"
                  >
                    <el-option
                      v-for="item in spamreason"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    placeholder
                    v-model="col.subwhy"
                    clearable
                    v-if="this.subwhy == 1"
                  ></el-input>
                 
               </ul>
               <ul v-if="this.ping_an_show==0" >
                  <li  >{{ $t("wasteInsulate1.bigs") }}:</li>
                  <div class="mailSize"  >
                    <el-input v-model="col.min_size"></el-input>
                    <el-select v-model="col.min_size_unit" placeholder="MB">
                      <el-option
                        v-for="item in size_unit"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option> </el-select
                    >{{ $t("wasteInsulate1.zhi") }}
                    <el-input v-model="col.max_size"></el-input>
                    <el-select v-model="col.max_size_unit" placeholder="MB">
                      <el-option
                        v-for="item in size_unit"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                  <li  >{{ $t("wasteInsulate1.attachment_size") }}:</li>
                  <div class="mailSize"  >
                    <el-input v-model="col.min_attsize"></el-input>
                    <el-select v-model="col.min_attsize_unit" placeholder="MB">
                      <el-option
                        v-for="item in size_unit"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option> </el-select
                    >{{ $t("wasteInsulate1.zhi") }}
                    <el-input v-model="col.max_attsize"></el-input>
                    <el-select v-model="col.max_attsize_unit" placeholder="MB">
                      <el-option
                        v-for="item in size_unit"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                 
                </ul>
                <ul  >
                   <li>{{ $t("tab.sort") }}:</li>

                  <el-select
                    v-model="col.q_order_type"
                    slot="prepend"
                    placeholder=""
                    style="width: 10%; padding-right: 0px"
                  >
                    <el-option
                      v-for="item in q_order_type_arr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="col.q_order_sort"
                    slot="prepend"
                    placeholder=""
                    style="width: 7%; padding-left: 0px"
                  >
                    <el-option
                      v-for="item in q_order_sort_arr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                   <li>{{ $t("wasteInsulate1.startdate") }}:</li>
                  <el-date-picker
                    v-model="col.startdate"
                    type="datetimerange"
                    :range-separator="$t('wasteInsulate1.zhi')"
                    :start-placeholder="$t('table.sdata')"
                    :end-placeholder="$t('table.enddata')"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="pickerOptions"
                    :default-time="['00:00:00', '23:59:59']"
                  ></el-date-picker>
                </ul>
              </div>
            </div>
 <!-- <div class="main main_custom_insulate"> -->
             
                <ul style="padding:5px 0;text-align:left">
                   <span  style="
                        font-family: PingFangSC-Regular, PingFang SC;
                        color: #0e2c5e;
                        margin-left:14px;
                       
                      "> {{ $t("logs.statistics_list") }}：</span>
                        <span  style="
                        font-family: PingFangSC-Regular, PingFang SC;
                        color: #f00;
                      
                       
                      ">{{this.userrule}}</span>
                 
                
                 
                </ul>
             
          
            <!-- </div> -->
            <!--  表格 -->

            <div class="table">
              <el-table
                :cell-class-name="tableCellClassName"
                v-loading="loading"
                :data="fileListnum"
             height="calc(100vh - 190px)"
            v-el-table-infinite-scroll="loadFile_list"
                highlight-current-row
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange"
                :row-key="getRowKeys"
                @cell-click="addSubAccount_prav"
                  @sort-change="sortChangeEvent"
              >
            
             

                <el-table-column
                  type="selection"
                  width="40"
                  :reserve-selection="true"
                  v-model="multipleSelection"
                ></el-table-column>
                <el-table-column :label="$t('table.tls')" width="40" v-if="this.ping_an_show==0">
                  <template slot-scope="scope" v-if="ping_an_show==0">
                    <img
                      v-if="scope.row.SHOWTLS == 0"
                      src="/imgs/tls2.png"
                      alt
                    />
                    <img
                      v-if="scope.row.SHOWTLS == 1"
                      src="/imgs/tls.png"
                      alt
                      title="tls"
                    />
                    <img
                      v-if="scope.row.SHOW_WL == 1"
                      src="/imgs/wls.png"
                      alt
                      :title="$t('table.wl')"
                    />
                    <img
                      v-if="scope.row.SHOW_WL == 0"
                      src="/imgs/wls2.png"
                      alt
                    />
                  </template>
                </el-table-column>

                <el-table-column
                  prop="AC_DATE"
                  :label="$t('table.maildate')"
                  width="104"
                   sortable="custom"
                >
                </el-table-column>
                <el-table-column
                  prop="SHOW_MINION"
                  :label="$t('table.clusterhost')"
                  width="96"
                  v-if="this.ping_an_show==0"
                ></el-table-column>
                <el-table-column prop="MID" :label="$t('table.ID')" width="92"   v-if="this.ping_an_show==0">
                  <template slot-scope="scope">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="scope.row.MID"
                      placement="top"
                    >
                      <span > {{ scope.row.MID }}</span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="IP" :label="$t('table.IP')" width="102"  v-if="this.ping_an_show==0"  sortable="custom">
                  <template slot-scope="scope">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="scope.row.IP"
                      placement="top"
                    >
                      <span> {{ scope.row.IP }}</span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!--  发件人 -->

                <el-table-column
                 sortable="custom"
                  prop="ENVFROM"
                  :label="$t('table.ENVFROM')"
                 
                >
                  <template slot-scope="scope">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="scope.row.ENVFROM"
                      placement="top"
                    >
                      <span :id="scope.row.REC_ID"> {{ scope.row.SHOW_ENVFROM }}</span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!--  收件人 -->

                <el-table-column
                 sortable="custom"
                  prop="ENVRCPT"
                  :label="$t('table.ENVRCPT')"
                 
                >
                  <template slot-scope="scope">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="scope.row.SHOW_MORE_RCPT"
                      placement="top"
                    >
                      <span> {{ scope.row.ENVRCPT }}</span>
                    </el-tooltip>
                  </template>
                  <!--  

                            <template slot-scope="scope">
                                <div>
                                    <p>
                                        {{
                        scope.row.SHOW_MORE == $t('table.show')
                          ? scope.row.SHOWRCPT
                          : scope.row.SHOW_MORE_RCPT
                      }}
                                        <el-button type="text" size="small" v-if="scope.row.SHOW_MORE" v-text="scope.row.SHOW_MORE" @click="handleEdit1(scope.$index, scope.row)"></el-button>
                                    </p>
                                </div>
                            </template>
                            -->
                </el-table-column>
                <!--  邮件主题-->

                <el-table-column prop="SUBJECT" :label="$t('table.SUBJECT')"  sortable="custom">
                  <template slot-scope="scope">
                    <el-tooltip
                      popper-class="tooltio_subject"
                      class="item tooltio_subject"
                      effect="dark"
                      :content="scope.row.SUBJECT"
                      placement="top"
                    >
                      <span> {{ scope.row.SHOW_SUBJECT }}</span>
                    </el-tooltip>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="SHOW_REASON"
                  :label="$t('table.SHOW_REASON')"
                  width="92"
                   v-if="this.ping_an_show==0"
                ></el-table-column>
                <el-table-column
                  prop="SIZE"
                  :label="$t('table.mailsize')"
                  width="60"
                   sortable="custom"
                ></el-table-column>
           
              </el-table>
            </div>

            <!--  分页 -->
            <div class="fenye" v-show="xian6">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="page"
                :page-sizes="this.q_page_size"
                :page-size="size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalnums"
              ></el-pagination>
              <el-button
                @click="ruetun_custom"
                style="color: #fff"
               
              >
                {{ $t("list.return") }}
              </el-button>
              <!-- <button
                @click="openPostWindow_custom"
                class="el-icon-download1"
               
                v-if="this.priv_json.download_message"
              >
                {{ $t("table.download") }}
              </button>
              <button
                @click="bulkpass"
                class="el-icon-finished1"
              
                v-if="this.priv_json.pass"
              >
                {{ $t("table.pass") }}
              </button>
              <button
                @click="data_delete"
                class="el-icon-del1"
              
                v-if="this.priv_json.delete"
              >
                {{ $t("table1.delete") }}
              </button> -->
<!--             
              <el-dropdown trigger="click" class="collect" v-if="this.priv_json.forward">
                <span
                  class="el-dropdown-link"
                  style="color: #006be7; margin-left: 10px"
                >
                  {{ $t("table.more_operations")
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>

                <el-dropdown-menu slot="dropdown" class="show_style_drop">
                  <ul class="tanchu_style" @click="archive_forward_tanchu_custom">
                    <el-dropdown-item command="">
                      {{ this.data_forword }}
                    </el-dropdown-item>
                  </ul>
                </el-dropdown-menu>
              </el-dropdown> -->
              <img src="../../../public/imgs/area_bulk.png" title="放行" class="style_img_ara"  @click="bulkpass"  v-if="this.priv_json.pass">
     <img src="../../../public/imgs/area_down.png" title="下载邮件" class="style_img_ara"  @click="openPostWindow_custom"  v-if="this.priv_json.download_message">
          <img src="../../../public/imgs/area_del.png" title="删除" class="style_img_ara"  @click="data_delete_area"    v-if="this.priv_json.delete" >
       
        
          <img src="../../../public/imgs/area_transmit.png" title="转发" class="style_img_ara"  @click="archive_forward_tanchu_custom"  v-if="this.priv_json.forward">

            </div>
          </div>
          <div
            class="pop-up pop-up1"
            v-show="tanchu_forward"
            v-drag="{ handle: '.pop_up_text_relay_domain' }"
          >
            <div class="pop_up_text pop_up_text_relay_domain">
              <span class="span_pad"></span>{{ this.data_forword }}
            </div>
            <p></p>
            <div class="find">
              <div class="find1">
                <div class="find-text" style="padding-right: 12px">
                  {{ this.data_forword }}:
                </div>
                <div class="block block1" style="display: flex">
                  <el-input
                    v-model="forword_email"
                    style="width: 100%"
                  ></el-input>
                </div>
              </div>
            </div>

            <el-row>
              <el-button type="primary" @click="save_archiveforward()">{{
                $t("logs.transmit")
              }}</el-button>
              <el-button type="danger" @click="tanOff_archive_forward()">{{
                $t("tab.cancel")
              }}</el-button>
            </el-row>
          </div>
          <div class="gray" v-show="tanchu_forward"></div>
          <div class="main1_warp">
            <!-- 按钮部分 -->

            <div class="main1" v-show="this.list_two == 1" id="main_btn">
              <el-button type="primary" @click="back">{{
                $t("list.return")
              }}</el-button>
              <el-button
                @click="xiazai"
               
                v-if="this.priv_json.download_message"
                >{{ $t("list.download") }}</el-button
              >
              <!-- 上报垃圾 -->
              <el-button
                v-if="this.priv_json.report_as_spam"
                @click="report_msg"
               
                >{{ $t("logs.as_good") }}</el-button
              >
              <el-button
                @click="pass"
                v-if="this.priv_json.pass &&this.has_pass_style == 0 "
              
                >{{ $t("list.pass") }}</el-button
              >
              <el-button
                @click="dawdata"
                v-if="this.priv_json.rawdata"
              
                >{{ $t("list.rawdata") }}</el-button
              >
              <el-button @click="header"  >{{ $t("list.header") }}</el-button>
              <el-button @click="reason"   :disabled=" this.readmsg_disabled==0" >{{ $t("list.whyspam") }}</el-button>
              <el-button @click="abstract" v-if="this.priv_json.show_digest"   :disabled=" this.readmsg_disabled==0" >{{
                $t("list.show")
              }}</el-button>
              <el-button @click="matter" v-if="this.priv_json.show_digest"   :disabled=" this.readmsg_disabled==0" >{{
                $t("list.body")
              }}</el-button>
              <el-button
                @click="original"
                  :disabled=" this.readmsg_disabled==0"
                v-if="this.priv_json.printoriginalbody"
                >{{ $t("list.origin") }}</el-button
              >
                <!-- 详细信息 -->
         <el-button
          @click="detail_click_show"
          v-if="this.detail_info_show==1"
           :disabled="$root.jurisdiction.only_query == 0 "
         
          >{{ $t("list.detail") }}</el-button
        >
              <el-button
                @click="print"
                 :disabled=" this.readmsg_disabled==0"
                v-if="this.priv_json.printparticipleinfo"
                >{{ $t("list.info") }}</el-button
              >
              <el-button
                v-if="this.priv_json.selfbuildbayes"
               
                >{{ $t("list.trainspam") }}</el-button
              >
              <el-button
                v-if="this.priv_json.selfbuildbayes"
              
                >{{ $t("list.trainnormal") }}</el-button
              >
              <el-button
                v-if="this.priv_json.delete"
                @click="readmsg_sum_area"
              
                >{{ $t("logs.Conditional8") }}</el-button
              >
              <el-button type="text" @click="up_email">{{
                $t("logs.up_mail1")
              }}</el-button>
              <el-button type="text" @click="next_email">{{
                $t("logs.next_mail1")
              }}</el-button>
            </div>
          </div>
          <div
            class="custom_xin custom_xin_body"
            id="main_btn1"
            v-loading="loading"
            v-show="this.list_two == 1"
          >
            <div class="swicth switch_custom">
              <!--内容区域 -->

              <div class="detail_type detail_type_custom">
                <!-- 内容区域 -->
                <div class="cent">
                  <!-- 分词信息 -->

                  <ol class="reason" v-show="print2">
                    <li>
                      {{ $t("list.info") }}:<el-button @click="yin4">{{
                        $t("list.hide")
                      }}</el-button>
                    </li>

                    <el-input type="textarea" :rows="10" v-model="print1">
                    </el-input>
                  </ol>
                  <!-- 原始正文 -->

                  <ol class="reason" v-show="original2">
                    <li>
                      {{ $t("list.origin") }}:<el-button @click="yin3">{{
                        $t("list.hide")
                      }}</el-button>
                    </li>

                    <el-input type="textarea" :rows="10" v-model="original1">
                    </el-input>
                  </ol>
                     <!-- 详细信息 -->

            <ol class="reason" v-show="detail_show">
              <li>
                {{ $t("list.detail") }}:<el-button @click="yin_detail">{{
                  $t("list.hide")
                }}</el-button>
              </li>

              <el-input type="textarea" :rows="10" v-model="detail_info">
              </el-input>
            </ol>
                  <!-- 正文分析 -->

                  <ol class="reason" v-show="matter2">
                    <li>
                      {{ $t("list.body") }}:<el-button @click="yin2">{{
                        $t("list.hide")
                      }}</el-button>
                    </li>
                    <li v-html="matter1"></li>
                  </ol>
                  <!-- 显示摘要 -->

                  <ol class="reason" v-show="abstract2">
                    <li>
                      {{ $t("list.show") }}:<el-button @click="yin1">{{
                        $t("list.hide")
                      }}</el-button>
                    </li>
                    <li v-html="abstract1"></li>
                  </ol>
                  <!-- 原因分析 -->
                  <ol class="reason" v-show="reason2">
                    <li>
                      {{ $t("list.whyspam") }}:<el-button @click="yin">{{
                        $t("list.hide")
                      }}</el-button>
                    </li>

                    <li style="white-space: pre-wrap">{{ reason1 }}</li>
                  </ol>

                  <p v-html="fileList.SUBJECT"></p>

                  <ul>
                    <li>{{ $t("list.from") }}:</li>
                    <li>
                      {{ fileList.FROMNAME }}
                      <span class="list_text">{{ fileList.FROMADDR }}</span>
                    </li>
                  </ul>
                  <ul>
                    <li>{{ $t("list.to") }}:</li>
                    <li class="list_text">{{ fileList.TO }}</li>
                  </ul>
                  <ul v-if="this.fileList.CC">
                    <li>{{ $t("list.cc") }}:</li>
                    <li>{{ fileList.CC }}</li>
                  </ul>
                  <ul>
                    <li>{{ $t("list.data") }}:</li>
                    <li class="list_text">{{ fileList.DATE }}</li>
                  </ul>
                   <ul v-if="fileList.HAS_RECTIME==1">
                <li>{{ $t("list.record_time") }}:</li>
                <li class="list_text">{{ fileList.RECTIME }} </li>
              </ul>
                  <ul v-if="fileList.ATTACHMENT == 1">
                    <li>{{ $t("list.attach") }}:</li>
                    <li class="yichu">
                      ({{ fnameage }} {{ $t("list.num") }} ){{ fname }}
                    </li>
                  </ul>
                  <!--  信封发件人 -->
                  <ul>
                    <li>{{ $t("list.envfrom") }}:</li>
                    <li>
                      {{ fileList.ENVFROM }}
                    </li>
                    <li v-if="fileList.ADD_BLACK_EMAIL_IN_SPAM == 1">
                      <el-button
                        @click="tan1"
                        
                        v-if="this.priv_json.add_bl_sender"
                        >{{ $t("list.bte") }}</el-button
                      >
                      <el-button
                        @click="tan2"
                        
                        v-if="this.priv_json.add_wl_sender"
                        >{{ $t("list.wte") }}</el-button
                      >
                    </li>
                    <!-- 加白名单 -->
                    <li v-if="fileList.ADD_WHITE_EMAIL_IN_USER_SPAM == 1">
                      <el-button @click="add_emali_white" >{{
                        $t("list.wte")
                      }}</el-button>
                    </li>
                    <li v-if="fileList.WHITE_EMAIL_IS_IN_USER_SPAM == 1">
                      {{ $t("tan.wte") }}
                      <el-button @click="del_email_white" >{{
                        $t("list.wte1")
                      }}</el-button>
                    </li>
                    <li v-if="fileList.BLACK_EMAIL_IS_IN_SPAM == 1">
                      {{ $t("tan.bte") }}
                      <el-button @click="tan11" >{{
                        $t("list.bte1")
                      }}</el-button>
                    </li>
                    <li v-if="fileList.DELETE_WHITE_EMAIL_IN_SPAM == 1">
                      {{ $t("tan.wte") }}
                      <el-button @click="tan12" >{{
                        $t("list.wte1")
                      }}</el-button>
                    </li>
                  </ul>
                  <ul>
                    <li>{{ $t("list.envrcpt") }}:</li>
                    <li>{{ fileList.ENVRCPT }}</li>
                  </ul>

                  <ul>
                    <li>{{ $t("list.id") }}:</li>
                    <li>{{ fileList.QUEUE_ID }}</li>
                  </ul>
                  <ul>
                    <li>{{ $t("list.ip") }}:</li>
                    <li>
                      {{ fileList.PEER_IP }}
                    </li>
                    <li v-if="fileList.ADD_BLACK_IP_IN_SPAM == 1">
                      <el-button
                        @click="tan3"
                        v-if="this.priv_json.add_bl_ip" 
                        >{{ $t("list.bti") }}</el-button
                      >
                      <el-button
                        @click="tan4"
                        v-if="this.priv_json.add_wl_ip" 
                        >{{ $t("list.wti") }}</el-button
                      >
                    </li>

                    <li v-if="fileList.DELETE_BLACK_IP_IN_SPAM == 1">
                      {{ $t("tan.bti1")
                      }}<el-button @click="tan13" >{{
                        $t("list.bti1")
                      }}</el-button>
                    </li>
                    <li v-if="fileList.DELETE_WHITE_IP_IN_SPAM == 1">
                      {{ $t("tan.wti1") }}
                      <el-button @click="tan14" >{{
                        $t("list.wti1")
                      }}</el-button>
                    </li>
                  </ul>
                  <ul v-if="this.fileList.REPLY_TO_ADDR">
                    <li>replyto:</li>
                    <li>
                      {{ fileList.REPLY_TO_NAME
                      }}<span style="color: #818ea8; margin-left: 4px"
                        >&lt;{{ fileList.REPLY_TO_ADDR }}&gt;</span
                      >
                    </li>
                  </ul>
                  <ul v-if="this.fileList.SENDER_ADDR">
                    <li>Sender:</li>
                    <li>
                      {{ fileList.SENDER_NAME
                      }}<span style="color: #818ea8; margin-left: 4px"
                        >&lt;{{ fileList.SENDER_ADDR }}&gt;</span
                      >
                    </li>
                  </ul>
                </div>

                <!-- 展示 -->
                <div
                  class="cent2"
                  id="cent2"
                  v-html="html"
                  v-if="this.priv_json.see_body"
                ></div>
                <!-- 附件 -->
                <div class="footer" v-if="fileList.ATTACHMENT == 1">
                  <p>
                    <img src="/imgs/fujian.png" alt />
                    {{ $t("list.fu") }}({{ fnameage }} {{ $t("list.num") }})
                  </p>
                  <div v-for="v in fujian" :key="v.id">
                    <img :src="`/imgs/${v.FILETYPE}.png`" alt />

                    <ul>
                      <li>{{ v.NAME }}({{ v.HSIZE }})</li>
                      <li @click="down_pric()">{{ $t("list.download") }}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { list_policy_details } from "../../tool/mixins.js";
import { garbageVirus } from "../../tool/elk_virus.js";
import { readmsg } from "../../tool/readmsg.js";


export default {
  mixins: [list_policy_details, garbageVirus,readmsg],

  data() {
    return {
      loading: false,
      refresh_loading: false,

      fileList2: [],
      fileList5: [],
      show_hint1: "",
      show_hint2: "",
      date_day: "",
      judge_the_refresh: 1,
    };
  },
  mounted() {
    this.getFileList_custom();
    this.timer_flush_true();
  },
  created() {
    let that = this;
    document.onkeydown = function (e) {
      e = window.event || e;
      // console.log(e.code)

      if (
        e.code == "Enter" ||
        e.code == "Num Enter" ||
        e.code == "NumpadEnter"
      ) {
        //验证在登录界面和按得键是回车键enter
        that.tanSend(); //搜索函数
      }
    };
  },
  beforeDestroy() {
    clearInterval(this.timer_flush);
    this.timer_flush = null;
  },
  methods: {
    save_archiveforward() {
      this.is_spam = 2;
      this.save_archive_forward();
    },
    timer_flush_true() {
      if (this.judge_the_refresh == 1) {
        this.timer_flush = setInterval(() => {
          setTimeout(this.getFileList_custom, 0);
        }, 1000 * 60);
      } else {
        clearInterval(this.timer_flush);
        this.timer_flush = null;
      }
    },
    ruetun_custom() {
      this.judge_the_refresh = 1;
      this.timer_flush_true();
      this.list_custom_two = 0;
      this.list_custom_one = 1;
      this.getFileList_custom()
    },
    // 详细数据
    handleClick1(val) {
      this.judge_the_refresh = 0;
      console.log(val);
      this.timer_flush_true();
      this.userrule = val;
      this.col.userrule = val;
      this.col.startdate = '';
      console.log(this.userrule, this.col.userrule);
      this.getFileList_1();
    },

    // 数据统计加载
    getFileList_custom() {
      this.refresh_loading = true;

      console.log("我一分钟刷新了");
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/elkspam.cgi", {
          params: {
            __mode: "list_user_spamrec",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.refresh_loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.refresh_loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.refresh_loading = false;
            this.fileList5 = res.data.ret.datalist;
            setTimeout(() => {
                sessionStorage.setItem("file_old", JSON.stringify(this.fileList5));
            }, 1000*3);
          

            if (sessionStorage.getItem("file_old")) {
              let file_old = JSON.parse(sessionStorage.getItem("file_old"));
              console.log("旧数据", file_old);
          
              for (let i = 0; i < this.fileList5.length; i++) {
              
                   if(this.fileList5[i].NUM >file_old[i].NUM){
                     console.log('有不同')
                            this.fileList5[i].color_show=1
                   }else{
                      this.fileList5[i].color_show=0
                     console.log('相同')
                   }
              }
            }else{
              console.log("来着")
               for (let i = 0; i < this.fileList5.length; i++) {
              
                
                   
                            this.fileList5[i].color_show=0
                  
              }
            }
            console.log(this.fileList5, "数据");
          }
        });
    },

    // 返回
    save_sender_hide() {
      this.list_custom_two = 0;
      this.list_custom_one = 1;
    },
    // 各行变色
    // tableRowClassName({ rowIndex }) {
    //   // console.log(row,rowIndex)
    //   if (rowIndex % 2 == 1) {
    //     return "warning-row";
    //     // console.log(2222)
    //   } else if (rowIndex % 2 !== 1) {
    //     return "success-row";
    //   }
    //   return "";
    // },
  },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

@import "../../css/custom_insulate.less";
@import "../../css/list_detail_insulate.less";
@import "../../css/breadcrumb.less";
@import "../../css/drag.less";
/deep/ .has-gutter th .cell,/deep/ .el-table__row td .cell{
  text-align: left;
}
/deep/ .has-gutter th:nth-child(1) .cell,/deep/ .el-table__row td:nth-child(1) .cell{
  text-align: center;
}
/deep/ .has-gutter th:nth-child(2) .cell,/deep/ .el-table__row td:nth-child(2) .cell{
  text-align: center;
}
/deep/ .el-table {
  .el-table__body-wrapper {
    overflow-x: hidden;
  }
}
.main-find {
  width: 100%;
  height: 50px;
  padding-left: 10px;
  // padding-bottom: 5px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: left;

  border: 2px solid #d2d7e6;
  background: #ffffff;

  span {
    margin-right: 8px;

    // width: 126px;
    // display: inline-block;
    color: #0e2c5e;
  }

  .el-input {
    margin-right: 8px;
    width: 20%;
    line-height: 26px;
    height: 26px;
    // padding: 5px 10px 5px 0;
  }

  // input 框高度
  /deep/ .el-input__inner {
    height: 32px;
    padding: 0 6px;
  }

  /deep/ .el-select {
    margin-right: 10px;
  }

  /deep/ .el-button {
    margin-right: 10px;
    // margin-left: 30px;
  }
}

// 隐藏滚动条
// .el-table ::-webkit-scrollbar {
//     width: 0px;
//     background: none;
// }

/deep/ .el-tabs__nav {
  padding-left: 16px;
}

.el-button + .el-button {
  margin-left: 0;
}
/deep/ .sent1 .cell {
  color: #16960e;
}
.show_style_drop {
  margin-bottom: 0px;
}
.custom_for_table {
  min-height: 8vh;
  background: #fff;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  display: flex;
  flex-wrap: wrap;
  
  .custom_for {
        box-shadow: -1px 1px 0px #D2D7E6;

    border-top: 1px solid #D2D7E6;
    border-right: 1px solid #D2D7E6;
    cursor: pointer;
    width: 18%;
    padding: 5px 5px;
    color: #0e2c5e;
    font-family: PingFangSC-Medium, PingFang SC;
  }
}
/deep/ .el-date-editor--datetimerange.el-input__inner {
  width: 330px;
}
</style>
